import type { MetricsProviderProps } from '@cabify/prom-react';
import { MetricsProvider } from '@cabify/prom-react';
import type { PropsWithChildren } from 'react';
import { env } from '../utils';

const gatewayFetchOptions = {
  headers: {
    Authorization: `Basic ${btoa(
      `${env.METRICS_CREDENTIALS_USER}:${env.METRICS_CREDENTIALS_PASS}`,
    )}`,
  },
};

export function CoreMetricsProvider({
  children,
  appName,
  owner = 'iQx',
  fetchOptions = gatewayFetchOptions,
  metricsAggregatorUrl = env.METRICS_URL,
  ...props
}: PropsWithChildren<MetricsProviderProps>) {
  return (
    <MetricsProvider
      appName={appName}
      owner={owner}
      fetchOptions={fetchOptions}
      metricsAggregatorUrl={metricsAggregatorUrl}
      {...props}
    >
      {children}
    </MetricsProvider>
  );
}
